module.exports = __webpack_public_path__ + "static/media/icon-print.c4621386.svg";